import {Button} from '@primer/react'

import styles from './Pill.module.css'

type PillProps = Omit<React.ComponentProps<typeof Button>, 'className' | 'size' | 'variant'>

export const Pill = (props: PillProps) => <Button {...props} size="large" variant="invisible" className={styles.Pill} />
